import coorPlotPhase from "../../../../content/posts/data-release-notes/modbases-remora/coorplot-phase.jsx";
import * as React from 'react';
export default {
  coorPlotPhase,
  React
};